<template>
  <div>
    <div class="row pt-3 l-m-b-20">
      <div class="col-9">
        <h1>Create New Role</h1>
      </div>
    </div>
    <div class="l-bg-white roles">
      <form @submit.prevent="save" autocomplete="no">
        <div class="row mb-4">
          <div class="col pr-1">
            <div class="select-wrap">
              <label>Role name</label>
              <input type="text" placeholder="name" v-model="role.name" class="form-control" />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col px-1">
            <div class="select-wrap">
              <label>Department</label>
              <simple-select v-model="role.department_id"
                             :options="departments"
                             placeholder="Select Department"
              />
            </div>
          </div>
          <div class="col pl-1">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="role.carrier_id"
                             :options="carriers"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="carrier_id" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h2 class="l-header-2">Permissions</h2>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <!-- Tabs -->
            <div class="row mb-3">
              <div class="col">
                <div class="mb-1 mr-4 nav nav-tabs nav-fill">
                  <div :class="[permissionsStep === 'all' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('all')"
                  >
                    All
                  </div>
                  <div :class="[permissionsStep === 'carriers' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('carriers')"
                  >
                    Carriers
                  </div>
                  <div :class="[permissionsStep === 'companies' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('companies')"
                  >
                    Companies
                  </div>
                  <div :class="[permissionsStep === 'leads' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('leads')"
                  >
                    Leads
                  </div>
                  <div :class="[permissionsStep === 'jobs' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('jobs')"
                  >
                    Jobs
                  </div>
                  <div :class="[permissionsStep === 'claims' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('claims')"
                  >
                    Claims
                  </div>
                  <div :class="[permissionsStep === 'users' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('users')"
                  >
                    Users
                  </div>
                  <div :class="[permissionsStep === 'movers' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('movers')"
                  >
                    Movers
                  </div>
                  <div :class="[permissionsStep === 'trucks' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('trucks')"
                  >
                    Trucks
                  </div>
                  <div :class="[permissionsStep === 'transactions' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('transactions')"
                  >
                    Transactions
                  </div>
                  <div :class="[permissionsStep === 'customers' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('customers')"
                  >
                    Customers
                  </div>
                  <div :class="[permissionsStep === 'settings' ? 'active' : '']" class="nav-item nav-link pointer"
                       @click="setPermissionsStep('settings')"
                  >
                    Settings
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Show All Permissions -->
        <section v-show="permissionsStep === 'all'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPerm"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input
                  type="checkbox" v-model="permission_ids" :value="permission.id" :key="index"
                  :id="'permissions_id-' + permission.id" class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Carriers Permissions -->
        <section v-show="permissionsStep === 'carriers'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in carrierPermissions"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input
                  type="checkbox" v-model="permission_ids"
                  :value="permission.id" :key="index"
                  :id="'permissions_id-' + permission.id"
                  class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Permissions -->
        <section v-show="permissionsStep === 'companies'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermCompanies"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Leads -->
        <section v-show="permissionsStep === 'leads'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermLeads"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Jobs -->
        <section v-show="permissionsStep === 'jobs'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermJobs"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Claims-->
        <section v-if="permissionsStep === 'claims'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermClaims"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="[{'check-open' : permission_ids.find((el) => el === permission.id)},
                                {'disabled': !$_can('carriers.roles.update')}]"
                >
                  <span class="checkmark" />{{ permission.description }}
                  <input type="checkbox" v-model="permission_ids"
                         :value="permission.id" :key="index"
                         :id="'permissions_id-' + permission.id"
                         :disabled="!$_can('carriers.roles.update')"
                         class="btn-check"
                  /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Users -->
        <section v-show="permissionsStep === 'users'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermUsers"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Movers -->
        <section v-show="permissionsStep === 'movers'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermMovers"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Trucks -->
        <section v-show="permissionsStep === 'trucks'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermTrucks"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Transactions -->
        <section v-show="permissionsStep === 'transactions'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermTransactions"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Customers -->
        <section v-show="permissionsStep === 'customers'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermCustomers"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <!-- Show Companies Settings -->
        <section v-show="permissionsStep === 'settings'">
          <div class="row mb-2 user-role">
            <div class="col-3"
                 v-for="(permission, index) in companyPermSettings"
                 :key="permission.id"
            >
              <div class="check-field">
                <label :for="'permissions_id-' + permission.id"
                       :class="{'check-open' : permission_ids.find((el) => el === permission.id)}"
                ><span
                  class="checkmark"
                />{{ permission.description }}<input type="checkbox" v-model="permission_ids"
                                                     :value="permission.id" :key="index"
                                                     :id="'permissions_id-' + permission.id"
                                                     class="btn-check"
                /></label>
              </div>
            </div>
          </div>
        </section>
        <div class="row mt-4">
          <div class="col">
            <h2 class="l-header-2">Notification types</h2>
          </div>
        </div>
        <section>
          <div class="row mb-2 user-role">
            <div class="col-5 d-flex justify-content-between align-items-center"
                 v-for="type in notificationTypes"
                 :key="type.id"
            >
              <div class="check-field">
                <label :for="'notification_types_id-' + type.id"
                       :class="{'check-open' : notification_type_ids.find((el) => el.id === type.id)}"
                ><span
                  class="checkmark"
                />{{ type.description }}<input
                  type="checkbox"
                  v-model="notification_type_ids"
                  :value="notification_type_ids.find((el) => el.id === type.id) ? notification_type_ids.find((el) => el.id === type.id) : type"
                  :key="type.id"
                  :id="'notification_types_id-' + type.id"
                  class="btn-check"
                /></label>
              </div>
              <div v-if="!type.disabled_only_own" class="d-flex align-items-center pl-2">
                <span class="pr-2" :class="{'disabled' : disabledAllLeads}">
                  All leads
                </span>
                <label class="switch mr-2">
                  <input type="checkbox"
                         @click="toggleSwitch(type, notification_type_ids.find((el) => el.id === type.id))"
                         v-model="onlyOwn"
                         :value="notification_type_ids.find((el) => el.id === type.id)"
                  />
                  <div class="slider round" />
                </label>
                <span :class="{'disabled' : disabledOnlyOwn}">
                  Only own
                </span>
              </div>
            </div>
          </div>
        </section>
        <div class="row mt-3 mb-2 text-right">
          <div class="col">
            <button type="button" class="btn btn-delete" @click="$router.push('/settings/user-roles')">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Create
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState, mapActions } from 'vuex';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'RolesCreate',
  components: {
    ErrorField,
  },
  data: () => ({
    companyPerm: [],
    departments: [],
    notificationTypes: [],
    role: {
      name: '',
      permission_ids: [],
      department: null,
      department_id: null,
      carrier_id: null,
    },
    showCreateModal: false,
    loadingButton: false,
    buttonDisabled: false,
    permission_ids: [],
    notification_type_ids: [],
    onlyOwn: [],
    permissionsStep: 'all',
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
      carriers: state => state.carriers.carriers.data,
      roles: state => state.roles.roles,
    }),
    carrierPermissions() {
      return this.companyPerm.filter(per => per.name.indexOf('carriers.') >= 0);
    },
    companyPermCompanies() {
      return this.companyPerm.filter(
        per =>
          per.name.indexOf('companies.') >= 0 &&
          per.name.indexOf('companies.truck') < 0 &&
          per.name.indexOf('companies.customers.') < 0 &&
          per.name.indexOf('customer-cards.') < 0 &&
          per.name.indexOf('carriers.movers') < 0,
      );
    },
    companyPermLeads() {
      return this.companyPerm.filter(per => per.name.indexOf('leads.') >= 0);
    },
    companyPermJobs() {
      return this.companyPerm.filter(
        per => per.name.indexOf('jobs.') >= 0 || per.name.indexOf('job-expenses.') >= 0,
      );
    },
    companyPermClaims() {
      return this.companyPerm.filter(per => per.name.indexOf('claims.') >= 0);
    },
    companyPermUsers() {
      return this.companyPerm.filter(
        per => per.name.indexOf('users.') >= 0 || per.name.indexOf('roles.') >= 0,
      );
    },
    companyPermMovers() {
      return this.companyPerm.filter(per => per.name.indexOf('movers.') >= 0);
    },
    companyPermTrucks() {
      return this.companyPerm.filter(per => per.name.indexOf('truck') >= 0);
    },
    companyPermTransactions() {
      return this.companyPerm.filter(per => per.name.indexOf('job-charges.') >= 0);
    },
    companyPermCustomers() {
      return this.companyPerm.filter(
        per =>
          per.name.indexOf('companies.customers.') >= 0 || per.name.indexOf('customer-cards.') >= 0,
      );
    },
    companyPermSettings() {
      return this.companyPerm.filter(
        per =>
          per.name.indexOf('email-templates.') >= 0 ||
          per.name.indexOf('phone-numbers.') >= 0 ||
          per.name.indexOf('automated-emails.') >= 0 ||
          per.name.indexOf('settings') >= 0,
      );
    },
    disabledAllLeads() {
      return (
        this.notification_type_ids.find(el => el.only_own === true) ||
        this.notification_type_ids.find(el => el.only_own === 1)
      );
    },
    disabledOnlyOwn() {
      return (
        this.notification_type_ids.find(el => el.only_own === false) ||
        this.notification_type_ids.find(el => el.only_own === 0) ||
        this.notification_type_ids.find(el => el.only_own === null)
      );
    },
  },
  created() {
    this.getPermissions();
    this.getDepartments();
    this.getNotificationTypes();
  },
  methods: {
    ...mapActions(['getRoles']),
    toggleSwitch(type, secondType) {
      type.only_own = !type.only_own;
      secondType.only_own = type.only_own;
    },
    getPermissions() {
      axios
        .get('/permissions')
        .then(res => {
          this.companyPerm = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getNotificationTypes() {
      axios.get('notification-types').then(res => {
        this.notificationTypes = res.data.data;
      });
    },
    getDepartments() {
      axios
        .get('/values/departments')
        .then(res => {
          this.departments = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    save() {
      const notTypes = [];
      this.role.permission_ids = this.permission_ids;
      this.notification_type_ids.forEach(el => {
        notTypes.push({
          notification_type_id: el.id,
          only_own: el.only_own ? el.only_own : 0,
        });
      });
      this.role.notification_types = notTypes;
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post('/roles', { ...this.role })
        .then(() => {
          this.$router.push('/settings/user-roles');
          toastr.success('Role saved');
          this.getRoles();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    deleteRole() {
      axios
        .delete(`/roles/${this.role.id}`)
        .then(() => {
          this.roles = this.roles.filter(role => role.id !== this.role.id);
          this.closeModal();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    setPermissionsStep(permission) {
      this.permissionsStep = permission;
    },
  },
};
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 18px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: -2px;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.check-field {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/UserRoles/SettingsUserRolesCreate.vue